import moment from 'moment';
import {Payment} from '../../interfaces';

const generateCsvRows = (data: Payment[]) => {
  let csvRows = '';

  for (const item of data) {
    const {
      createdAt,
      type,
      processed,
      reference,
      memberPK,
      amount,
      currency,
    } = item;
    const date: number = createdAt ? parseInt(createdAt, 10) : null;

    csvRows += [
      `${(date && moment(date).format('DD-MM-YYYY')) || '-'},`,
      `${type || '-'},`,
      `${processed ? 'Yes' : 'No'},`,
      `${reference || '-'},`,
      `${memberPK || '-'},`,
      `${amount || '-'},`,
      `${currency || '-'}`,
      '\r\n',
    ].join('');
  }

  return csvRows;
};

export const createCsv = (data: Payment[], linkRef: HTMLAnchorElement) => {
  /*
    id: string;
    type: string;
    reference: string;
    memberPK?: string;
    amount: number;
    currency: string;
    history: History[];
    processed: boolean;
    createdAt: string;
  */

  let csvContent = 'data:text/csv;charset=utf-8,' + [
    'Date,',
    'Type,',
    'Paid,',
    'Reference,',
    'Member_ID,',
    'Amount,',
    'Currency',
    '\r\n',
  ].join('');

  csvContent += generateCsvRows(data);

  const encodedUri = encodeURI(csvContent);
  linkRef.href = encodedUri;
  linkRef.download = `submission-list-export-${moment().format('YYYY-MM-DD, HHmm')}.csv`;
  linkRef.click();
};



// WEBPACK FOOTER //
// ./src/pages/PaymentHistoryPage/components/ExportModal/exportModalUtils.ts